const $ = jQuery;

export const handleRestart = (callback) => {
    const $restart = $('.js-archive--restart');
    if (!$restart.length) return;

    $restart.on('click', function () {
        $('.js-archive--active-filters').slideUp(200);

        setTimeout(() => {
            const $activeOptions = $('.js-archive--active-option');
            $activeOptions.remove();
        }, 250);

        const $activeOptions = $('.js-filter-dropdown--option');
        $activeOptions.removeClass('selected');
        $activeOptions.siblings('.js-filter-dropdown--option[data-slug="all"]').addClass('selected');

        callback();

        const $locationDropdown = $('.filter-dropdown[data-name="location"]');
        $locationDropdown.addClass('disabled');
        $locationDropdown.find('.filter-dropdown__container').slideUp(200);
    });
};

export const handleDisableFilter = (callback) => {
    $(document).on('click', '.js-archive--active-filters-icon', function () {
        const $option = $(this).closest('.js-archive--active-option');
        const taxonomy = $option.data('name');
        const $dropdown = $(`.js-filter-dropdown[data-name="${taxonomy}"]`);

        $dropdown.find('.js-filter-dropdown--option').removeClass('selected');
        $dropdown.find(`.js-filter-dropdown--option[data-slug="all"]`).addClass('selected');

        if (taxonomy === 'instance') {
            const $locationDropdown = $('.filter-dropdown[data-name="location"]');
            $locationDropdown.addClass('disabled');
            $locationDropdown.find('.filter-dropdown__container').slideUp(200);
            $locationDropdown.find('.js-filter-dropdown--option').removeClass('selected');
            $locationDropdown.find(`.js-filter-dropdown--option[data-slug="all"]`).addClass('selected');
            $option.siblings('.js-archive--active-option[data-name="location"]').remove();
        }

        $option.remove();

        if (!$('.js-archive--active-option').length) {
            $('.js-archive--active-filters').slideUp(200);
        }

        callback();
    });
};

export const addActiveOption = ($option) => {
    const dropdown = $option.closest('.js-filter-dropdown');
    const taxonomy = dropdown.data('name');
    const slug = $option.data('slug');
    const activeFilterInTaxonomy = $(`.js-archive--active-option[data-name="${taxonomy}"]`);

    if (slug === 'all') {
        if (activeFilterInTaxonomy.length) {
            activeFilterInTaxonomy.remove();
        }

        if (!$('.js-archive--active-option').length) {
            $('.js-archive--active-filters').slideUp(200);
        }

        return;
    }

    const $activeFilters = $('.js-archive--active-filters');
    const $container = $activeFilters.find('.js-archive--active-filters-buttons-container');

    const $newOption = $(`<button class="active-filters__button js-archive--active-option" data-slug="${slug}" data-id="${$option.data('id')}" data-name="${taxonomy}">
                            <span>${$option.text()}</span>
                            <svg class="js-archive--active-filters-icon" width="10" height="11" viewbox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.98741 1.5L1.01259 9.5" stroke-width="1.5" stroke-linejoin="round"/>
                                <path d="M1 1.51252L9 9.48735" stroke-width="1.5" stroke-linejoin="round"/>
                            </svg>
                        </button>`);

    if (activeFilterInTaxonomy.length) {
        activeFilterInTaxonomy.remove();
    }

    $container.append($newOption);
    $('.js-archive--active-filters').slideDown(200);
};
